// src/components/Navbar.tsx
import { AppBar, Toolbar, Typography, Button, IconButton, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import { styled } from "@mui/system";

interface NavbarProps {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
}

// Custom styled AppBar with a white background and shadow
const StyledAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "#FFFFFF",
  color: theme.palette.primary.main,
  boxShadow: "0px 2px 4px #90caf9",
  transition: "all 0.3s ease",
  "&:hover": {
    boxShadow: "0px 4px 8px #90caf9",
  },
}));

const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 700, // Bold font weight
  fontSize: "1.5rem", // Larger font size
  color: theme.palette.primary.main, // Use primary color from the theme
  letterSpacing: "0.05rem", // Slight letter spacing for better readability
  transition: "color 0.3s ease", // Smooth transition for hover effect
  "&:hover": {
    color: theme.palette.info.light, // Use secondary light color for hover (e.g., #90caf9)
  },
}));

// Custom styled Button for logout
const LogoutButton = styled(Button)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 500,
  textTransform: "none",
  "&:hover": {
    backgroundColor: theme.palette.action.hover,
    color: theme.palette.error.main,
  },
}));

const Navbar = ({ sidebarOpen, toggleSidebar }: NavbarProps) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("accessToken");
    navigate("/login");
  };

  return (
    <StyledAppBar position="fixed" sx={{ zIndex: 1300 }}>
      <Toolbar>
        {/* Sidebar Toggle Button */}
        <IconButton
          color="inherit"
          aria-label="toggle sidebar"
          onClick={toggleSidebar}
          edge="start"
          sx={{ mr: 2, color: "primary.main" }}
        >
          <MenuIcon />
        </IconButton>

        {/* Title */}
        <Box sx={{ flexGrow: 1 }}>
          <Title variant="h6">
           Hire Smart 
          </Title>
        </Box>

        {/* Logout Button */}
        <LogoutButton
          onClick={handleLogout}
          startIcon={<LogoutIcon />}
        >
          Logout
        </LogoutButton>
      </Toolbar>
    </StyledAppBar>
  );
};

export default Navbar;